import React from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";

const Subscription = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="space-y-10">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            Manage Subscription
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbActive={"Subscription"}
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
        <div className="grid grid-cols-2 gap-4 mt-5">
          <button
            className="bg-themeBtn p-5 text-white rounded-lg"
            onClick={() => navigate("/user-tester")}
          >
            Manage Free Users
          </button>
        </div>
      </div>
    </>
  );
};

export default Subscription;
